<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 询价单详情 两个组件 根据不同状态展示不同的组件 和组件里面的进度条 -->
<!--
  0: "草稿", // 已保存
  1: "待审核", // 有
  2: "待报价", // 有
  3: "待揭示", // 有
  4: "已揭示", // 有
  5: "询价完成", // 有
  6: "生成订单", // 已下单 没有
  7: "订单完成", // 有
  8: "询价作废", // 没有
  9: "审核拒绝", // 有
  10: "询价过期" // 没有
  11: "待审批", // 新
 -->
<template>
  <div class="container">
    <enquiry-detail-com
      v-if="enquiryDetail"
      :enquiry-status="enquiryStatus"
      :is-choice="isChoice"
      @queryAuditBusinessFlowLogList="queryAuditBusinessFlowLogList"
    />
    <!-- <choose-business-priceDetail-detail v-if="true" /> -->
    <choose-business-priceDetail-detail
      v-if="chooseBusinessPriceDetailDetail"
      :enquiry-status="enquiryStatus"
      :is-choice="isChoice"
      @getCreateSource="getCreateSource"
      @queryAuditBusinessFlowLogList="queryAuditBusinessFlowLogList"
    />
    <!-- 审批流组件-->
    <approval-process :approval-data="approvalData" approval-title="发起审批记录" class="approval-wrapper" />
    <!--悬赏定价的审批流展示-->
    <approval-process
      v-if="setPriceApprovalData.length > 0"
      :approval-data="setPriceApprovalData"
      approval-title="选商定价审批记录"
    />
    <div class="handle-button">
      <div class="btn back-btn" @click="goBack">< 返回</div>
      <div class="sub-btn">
        <!-- 待报价、待揭示、已揭示、询价完成、生成订单、询价作废、询价过期、选商定价待审批 -->
        <div v-if="isDelayBtn && createSource !== 2" class="btn submit-btn" @click="openDelayDialog">查看延时记录</div>
        <div v-if="isPrintBtn && createSource !== 2" class="btn submit-btn" @click="handlePrint">打印</div>
      </div>
    </div>

    <delay-dialog
      dialog-title="延时记录"
      :dialog-visible.sync="dialogVisible"
      :table-label="tableLabel"
      :table-data="delayTableData"
    />
  </div>
</template>
<script>
import approvalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/enquiry';
import ChooseBusinessPriceDetailDetail from '../components/chooseBusinessPriceDetail.vue';
import EnquiryDetailCom from '../components/enquiryDetailCom.vue';
import DelayDialog from '../components/delayDialog';

export default {
  components: {
    EnquiryDetailCom,
    ChooseBusinessPriceDetailDetail,
    approvalProcess,
    DelayDialog,
  },
  data() {
    return {
      createSource: 0,
      approvalData: [],
      setPriceApprovalData: [], // 悬赏定价审批流数据
      firstData: {},
      dialogVisible: false,
      tableLabel: [
        {
          label: '操作人',
          param: 'createMemberName',
          align: 'center',
          width: '200',
        },
        {
          label: '延时发起时间',
          param: 'createTime',
          align: 'center',
          width: '200',
        },
        {
          label: '报价截止时间',
          param: 'quotationDeadlineStr',
          align: 'center',
          width: '200',
        },
        {
          label: '延时原因',
          param: 'remark',
          align: 'center',
          width: '420',
        },
      ],
      delayTableData: [],
      enquiryStatus: 0,
      purchaseCompanyId: '',
      enquiryPower: true,
      /* viewOfferCount: -1,
      isSameCompanyId: false, */
      isChoice: false,
    };
  },
  computed: {
    companyId() {
      return this.$store.state.USERINFO.companyId;
    },
    // { name: '全部', id: null },
    // { name: '草稿', id: 0 },
    // { name: '待平台审核', id: 1 },
    // { name: '待报价', id: 2 },
    // { name: '待揭示', id: 3 },
    // { name: '已揭示', id: 4 },
    // { name: '询价完成', id: 5 },
    // /* { name: '退回', id: 6 }, */
    // { name: '生成订单', id: 7 },
    // { name: '询价作废', id: 8 },
    // { name: '审核拒绝', id: 9 },
    // { name: '询价过期', id: 10 },
    // { name: '待审批', id: 11 },
    // { name: '选商定价待审批', id: 12 },
    // { name: '审批拒绝', id: 13 },
    // { name: '中选通知待确认', id: 14 },
    enquiryDetail() {
      if (!this.enquiryStatus) return false;
      const arr = [0, 1, 2, 3, 4, 9, 10, 11, 13];
      return arr.includes(Number(this.enquiryStatus));
    },
    chooseBusinessPriceDetailDetail() {
      if (!this.enquiryStatus) return false;
      const arr = [5, 6, 7, 12, 14];
      return arr.includes(Number(String(this.enquiryStatus)));
    },
    // 2、待报价、待揭示、已揭示、询价完成、生成订单、询价作废、询价过期、选商定价待审批  状态增加查看延时记录；
    isDelayBtn() {
      const enquiryStatusList = ['2', '3', '4', '5', '7', '8', '10', '12'];
      return enquiryStatusList.includes(String(this.enquiryStatus));
    },
    // 2、询价完成、生成订单 状态可以打印询价单；
    isPrintBtn() {
      const enquiryStatusList = ['5', '7'];
      return enquiryStatusList.includes(String(this.enquiryStatus));
    },
  },
  mounted() {
    const { enquiryId } = this.$route.query;
    this.getDetailInfo({ enquiryId: Number(enquiryId) });
  },
  methods: {
    async getDetailInfo(params) {
      const result = await Api.checkEnquiryPower({
        enquiryId: params.enquiryId,
        checkType: 0,
      });
      if (result.code === '200') {
        if (!result.data) {
          this.enquiryPower = false;
          this.$message.warning('暂无权限查看此信息。');
          this.$router.replace('/enquiryManage/enquiry');
          return;
        }
      }

      this.detailLoading = true;
      await Api.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          this.purchaseCompanyId = res.data.purchaseCompanyId;
          this.enquiryStatus = res.data.enquiryStatus;
          if (this.enquiryStatus !== Number(this.$route.query.enquiryStatus)) {
            // this.$message.warning('暂无权限查看此信息。');
            this.$message({
              duration: 5000,
              type: 'warning',
              message: '暂无权限查看此信息。',
            });
            this.$router.replace('/enquiryManage/enquiry');
            return;
          }
          if (this.enquiryStatus !== 8 || this.enquiryStatus !== 10) {
            this.isChoice = res.data.purchaseCompanyId === this.companyId;
          } else {
            this.isChoice = true;
          }
          // this.isChoice = res.data.purchaseCompanyId === this.companyId; // && res.data.viewOfferCount >= 1;
          this.getTableList(res.data.purchaseCompanyId);
          console.log(this.isChoice, 'this.isChoice');
        }
      });
    },
    getCreateSource(createSource) {
      console.log(createSource, 'createSourcecreateSourcecreateSource');
      this.createSource = createSource;
    },
    openDelayDialog() {
      this.dialogVisible = true;
    },
    async getTableList(purchaseCompanyId) {
      const { enquiryId: enquiryOfferId } = this.$route.query;
      const params = {
        changeTypeList: [2],
        enquiryOfferId,
        companyId: purchaseCompanyId,
      };
      const result = await Api.queryEnquiryOfferChangeList(params);
      if (result.code === '200') {
        result.data.forEach((el) => {
          el.quotationDeadlineStr = JSON.parse(el.changeDataJson).quotationDeadlineStr;
        });
        this.delayTableData = [...result.data];
        console.log(this.delayTableData);
      }
    },
    handlePrint() {
      const { enquiryId } = this.$route.query;
      const { href } = this.$router.resolve({
        path: '/enquiryOption',
        query: { enquiryId },
      });
      window.open(href, '_blank');
    },
    goBack() {
      this.$router.push({ path: '/enquiryManage/enquiry' });
    },
    // 获取审批流数据
    async queryAuditBusinessFlowLogList(firstData, handleData, setPriceFirstData, purchaseCompanyId) {
      // 没有权限直接返回
      if (!this.enquiryPower) {
        return false;
      }

      const params = {
        companyId: purchaseCompanyId,
        businessId: this.$route.query.enquiryId,
        businessAuditType: 5, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      this.purchaseCompanyId = purchaseCompanyId;
      const res = await Api.queryAuditBusinessFlowLogList(params);
      if (res.code === '200') {
        const data = res.data || [];
        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        this.firstData = firstData;

        // 询比价封装最后一条数据  待审批   0-待审批; 1-审批通过; 2-审批拒绝;  3-审批中
        // 运营商待审核：11、13
        // 运营商审核中：1
        // 运营商审核拒绝：9
        // 运营商审核成功：2，3，4，5，6，7，8，10

        const lastData = {
          auditStatus: '',
          step: '台审批',
          tip: '若有问题，可咨询致电平台运营张经理，电话：0898-65860160',
          nodeMember: {
            auditMemberName: '易派客平台审核',
            auditRemark: handleData.refuseReason || '',
          },
          nodeMemberList: [
            {
              auditMemberName: '易派客平台审核',
            },
          ],
        };
        if (handleData.enquiryStatus === 1) {
          // 审核中
          lastData.auditStatus = 3;
        } else if (handleData.enquiryStatus === 11 || handleData.enquiryStatus === 13) {
          // 待审核
          lastData.auditStatus = 0;
        } else if (handleData.enquiryStatus === 9) {
          // 审核拒绝
          lastData.auditStatus = 2;
        } else {
          lastData.auditStatus = 1;
        }

        data.push(lastData);

        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
      this.queryAuditSetPriceFlowLogList(setPriceFirstData);
    },
    // 获取选商定价的审批流数据
    async queryAuditSetPriceFlowLogList(setPriceFirstData) {
      const params = {
        companyId: this.purchaseCompanyId,
        businessId: this.$route.query.enquiryId,
        businessAuditType: 6, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:选商定价
      };
      const res = await Api.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];
        // 封装发起审批 的数据 插入第一条
        data.unshift(setPriceFirstData);
        // 审批流数据封装
        this.setPriceApprovalData = stepUtils.dealStepData(data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.approval-wrapper {
  background: #fff;
}
.handle-button {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .back-btn {
    background: #fff;
    color: #333;
    border: 1px solid #dcdfe6;
  }
  .btn {
    min-width: 80px;
    text-align: center;
    height: 30px;
    line-height: 27px;
    padding: 0 10px;
    cursor: pointer;
  }
  .right-btn {
    display: flex;
  }
  .reset-btn {
    background: #e8efff;
    border: 1px solid #2587ff;
    color: #2587ff;
    margin-right: 30px;
    line-height: 27px;
    &:hover,
    :active {
      background-color: #126edf;
      color: #fff;
    }
  }
  .submit-btn {
    background: #2587ff;
    border: 1px solid #2587ff;
    color: #ffffff;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
  .sub-btn {
    display: flex;
  }
}
</style>
